export { default as Spacer } from './component';
export { useSpacer } from './hook';